// axios エラーから HTTP ステータスを取り出す（未知の形なら undefined）。
// ドメインを問わず catch 節での status 分岐に使う共通ヘルパー。
// `error as AxiosError` の生キャストを各所に散らさないため、取り出しはここに一本化する。
export const extractHttpStatus = (error: unknown): number | undefined =>
  (error as { response?: { status?: number } })?.response?.status;
